import PromtForm from './_form'
import template from './new.pug'
import API from 'js/services/api'

export default Vue.extend({
  template: template(),
  components: {
    PromtForm
  },
  data() {
    return {
      errors: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('promtsAi.new.title'))
    this.$setBreadcrumbs([
      {label: this.$t('promtsAi.breadcrumbs.promtsAi.index'), route: {name: 'promts-ai-index', params: {id: this.$route.params.id}}},
      {label: this.$t('promtsAi.breadcrumbs.promtsAi.new'), route: {}}
    ])
  },
  methods: {
    createPromt(data) {
      API.promtsAi.create(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('promtsAi.new.succesfullyCreated'))
        this.$router.push({name: 'accounts-laia-promts', params: {id: this.$route.params.id}})
      })
    }
  }
})
